function padTime(value) {
  var _val = parseInt(value, 10);

  return _val >= 10 ? _val.toString() : "0".concat(_val);
}

export { padTime };